import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import './MetDisplay.css';

function MetDisplay(props) {
  const { metString, weather } = props;
  const { humidity, wind_kph, cloud, wind_dir } = weather;

  const windFloor = Math.floor(wind_kph);
  const wind = wind_dir > -999 ? `${windFloor} kph@${wind_dir} deg` : `${windFloor} kph`;

  const flagArray = metString.split(/[ ]+/);
  const met_r_state = flagArray[0].charAt(1);
  const met_c_state = flagArray[1].charAt(1);
  const met_w_state = flagArray[2].charAt(1);
  const met_h_state = flagArray[3].charAt(1);
  const met_d_state = flagArray[5].charAt(1);

  const regexD = new RegExp(/DP([^/]+C)\//);
  const dp = regexD.exec(cloud);
  const dp_temp = dp[1];

  const statusReport = {
    o: 'ok',
    c: 'wait',
    s: 'wait',
    x: 'bad',
    NA: 'na'
  }

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell><b>Element</b></TableCell>
            <TableCell><b>Last value</b></TableCell>
            <TableCell><b>State</b></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow key='clouds'>
            <TableCell>Clouds</TableCell>
            <TableCell></TableCell>
            <TableCell className={statusReport[met_c_state]}>
              {statusReport[met_c_state].toUpperCase()}
            </TableCell>
          </TableRow>
          <TableRow key='wind'>
            <TableCell>Wind</TableCell>
            <TableCell>{`${wind} `}</TableCell>
            <TableCell  className={statusReport[met_w_state]}>
              {statusReport[met_w_state].toUpperCase()}
            </TableCell>
          </TableRow>
          <TableRow key='rain'>
            <TableCell>Rain</TableCell>
            <TableCell></TableCell>
            <TableCell  className={statusReport[met_r_state]}>
              {statusReport[met_r_state].toUpperCase()}
            </TableCell>
          </TableRow>
          <TableRow key='hum'>
            <TableCell>Humidity</TableCell>
            <TableCell>{`${humidity}%`}</TableCell>
            <TableCell  className={statusReport[met_h_state]}>
              {statusReport[met_h_state].toUpperCase()}
            </TableCell>
          </TableRow>
          <TableRow key='dew'>
            <TableCell>Dew point</TableCell>
            <TableCell>{dp_temp}</TableCell>
            <TableCell  className={statusReport[met_d_state]}>
              {statusReport[met_d_state].toUpperCase()}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default MetDisplay;